<template>
    <div class="row col-12 d-flex justify-content-center p-0 m-0">
      <router-link to="/en-gb">
        <img class="harrodsLogo mt-2" src="@/assets/harrods.png" placeholder="Harrods Logo">
      </router-link>
    </div>
</template>

<script>
export default {
  name: 'HarrodsLogo',
  props: {
    msg: String
  }
}
</script>

<style lang="scss" scoped>
.harrodsLogo {
    height: 55px;
}
</style>
